import {
  Box,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RunChart from "../../../../components/runchart";
import * as XLSX from "xlsx";
import Title from "../../../../components/Title";
import {
  getMeasurementResults,
  getRunChartInterpretation,
  interpretation,
} from "../dataEntryService";
import { useLocation } from "react-router-dom";

const ViewData = () => {
  const [data, setData] = React.useState<any[]>([]);
  let median = data[data.length - 1]?.median;
  const [chartAnalysis, setChartAnalysis] = React.useState<interpretation[]>(
    []
  );
  const [interpretationDescription, setInterpretationDescription] =
    React.useState<string[]>([]);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const location = useLocation();

  let measurement;
  let project: string;
  let type: string;
  if (location.state) {
    measurement = location.state.measurement;
    project = location.state.project;
    type = location.state.type;
  } else {
    measurement = {};
    project = "";
    type = "";
  }
  useEffect(() => {
    getMeasurementResults(measurement?.id).then((res) => {
      if (res) {
        setData(res);
      } else {
        console.log("Error fetching data");
      }
    });
  }, []);

  const showRunChart = () => {
    let analysis = getRunChartInterpretation(data, median);
    setChartAnalysis(analysis.interpretation);
    setInterpretationDescription(analysis.description);
    onOpen();
  };

  const exportToExcel = () => {
    setTimeout(() => {
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Trigger download
      XLSX.writeFile(workbook, `${project}/${measurement.name}.xlsx`);
    }, 2000);
  };
  return (
    <Box>
      <Drawer
        size={"full"}
        isOpen={isOpen}
        placement="bottom"
        onClose={onClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader
            w={"90%"}
            style={{ textAlign: "left", fontSize: 18 }}
          ></DrawerHeader>

          <DrawerBody>
            <RunChart
              data={data.map((value) => ({
                time: value.created_at.split("T")[0],
                performance: value.result,
                Median: data[data.length - 1].median,
              }))}
              project={project as string}
              measurement={measurement.name as string}
              showInterpretation={true}
              chartInterpretation={chartAnalysis.join(", ")}
              chartInterpretationDescription={interpretationDescription}
            />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <Box
        display={"flex"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        alignContent={"center"}
        gap={4}
        marginBottom={4}
      >
        <Title
          title={`${project}/${measurement.name} Data` as string}
          onClick={() => {
            navigate("/data-entry");
          }}
        />
        <Button
          colorScheme="blue"
          fontWeight={"semi-bold"}
          fontSize={"sm"}
          onClick={() => {
            showRunChart();
          }}
        >
          View Run Chart
        </Button>
        <Button
          colorScheme="green"
          fontWeight={"semi-bold"}
          fontSize={"sm"}
          onClick={exportToExcel}
        >
          Export to excel
        </Button>
      </Box>

      <TableContainer mx={20}>
        <Table variant="simple" size="md">
          <Thead>
            <Tr>
              <Th>#</Th>
              <Th colSpan={2}>Date Entered on</Th>
              <>
                {type === "Percentage" ? (
                  <Th>Value</Th>
                ) : (
                  <>
                    <Th>Numerator</Th>
                    <Th>Denominator</Th>
                  </>
                )}
              </>

              <Th>Performance</Th>
              <Th>Median (baseline)</Th>
            </Tr>
          </Thead>
          <Tbody>
            {data.map((item, index) => (
              <Tr>
                <Td style={{ fontWeight: "normal" }}>{index + 1}</Td>
                <Td style={{ fontWeight: "normal" }} colSpan={2}>
                  {item.created_at.toString().split("T")[0]}
                </Td>
                <>
                  <Td>{item?.results[0]?.result}</Td>
                  <Td>{item?.results[1]?.result}</Td>
                </>
                <Td>{item?.result}</Td>

                <Td>{item?.median}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ViewData;
